import { Suspense, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import { PageLoader } from './PageLoader'
import { ActiveRepoSync } from './ActiveRepoSync'
import { ToastContainer } from '../ui/Toast'

// ── AppShell ──────────────────────────────────────────────────────────────────
//
// Persistent chrome rendered for every authenticated route.
// Layout: [Sidebar | (TopBar over main content)]
//
//   ┌──────────┬──────────────────────────────┐
//   │          │  TopBar (h-14)               │
//   │ Sidebar  ├──────────────────────────────┤
//   │ (w-56 or │  <main>                      │
//   │   w-14)  │    <Outlet />                │
//   │          │                              │
//   └──────────┴──────────────────────────────┘

export function AppShell(): JSX.Element {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <div className="flex h-screen overflow-hidden bg-canvas" data-testid="app-shell">
      {/* Keeps the active git connection ↔ selectedRepo in sync (renders null) */}
      <ActiveRepoSync />

      {/* Left sidebar */}
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />

      {/* Right column: top bar + scrollable main */}
      <div className="flex flex-col flex-1 min-w-0">
        <TopBar sidebarCollapsed={collapsed} />

        <main
          className="flex-1 overflow-y-auto bg-pool p-6"
          data-testid="main-content"
        >
          <Suspense fallback={<PageLoader />}>
            <Outlet />
          </Suspense>
        </main>
      </div>

      {/* Toast notifications — renders in bottom-right corner */}
      <ToastContainer />
    </div>
  )
}
